import React from 'react'
import ChatAdminParentRoot from './ChatAdminParentRoot'
import LoaderComp from "../../LoaderComp";


export default function ChatAdmin() {
  console.log("arewerhere?s")
  return (
    <div style={{ height: "100%" }}>
      {/* <div style={{marginBottom:"10px"}}>is it well below me !!</div> */}

      <div id='load_qchat' style={{ width: "100%", height: "100%" }}>


        <LoaderComp />

      </div>
      {/* <div>below</div> */}

      <ChatAdminParentRoot />



    </div>
  )
}